import { render, staticRenderFns } from "./svgVivostore.vue?vue&type=template&id=073d5fdc"
import script from "./svgVivostore.vue?vue&type=script&lang=js"
export * from "./svgVivostore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports